import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogActions,
    Button,
    Box,
    Typography,
    IconButton,
    Fade
} from '@mui/material';
import { Close, Description } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { appColors } from "../../constants/theme";


const AgreementDialog = ({ open, onClose, agreementPage }) => {
    const { t } = useTranslation();

    const getAgreementTitle = () => {
        // agreementPage prop'undan başlığı çıkar
        if (agreementPage) {
            // React component'in type'ından başlığı belirle
            const componentName = agreementPage.type?.name || agreementPage.type?.displayName;
            if (componentName === 'UserAgreement') return t('user_agreement');
            if (componentName === 'TermsOfUse') return t('terms_of_use');
            if (componentName === 'PrivacyAgreement') return t('privacy_agreement');
        }
        return t('agreement');
    };

    const renderAgreementPage = () => {
        return agreementPage;
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            TransitionComponent={Fade}
            transitionDuration={300}
            PaperProps={{
                sx: {
                    borderRadius: '16px',
                    maxHeight: '90vh',

                }
            }}
        >
            {/* Header */}
            <DialogTitle
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    p: 3,
                    pb: 2,
                    borderBottom: `1px solid ${appColors.gray200}`,
                    background: `linear-gradient(135deg, ${appColors.gray50} 0%, ${appColors.gray50} 100%)`
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Box
                        sx={{
                            width: 40,
                            height: 40,
                            borderRadius: '50%',
                            background: `linear-gradient(135deg, ${appColors.info} 0%, ${appColors.infoDark} 100%)`,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <Description sx={{ color: 'white', fontSize: 20 }} />
                    </Box>
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: 600,
                            color: appColors.gray900,
                            background: `linear-gradient(135deg, ${appColors.info} 0%, ${appColors.infoDark} 100%)`,
                            backgroundClip: 'text',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent'
                        }}
                    >
                        {getAgreementTitle()}
                    </Typography>
                </Box>
                <IconButton
                    onClick={onClose}
                    sx={{
                        color: appColors.gray500,
                        '&:hover': {
                            color: appColors.gray900,
                            background: 'rgba(107, 114, 128, 0.1)'
                        }
                    }}
                >
                    <Close />
                </IconButton>
            </DialogTitle>

            {/* Content */}
            <Box
                sx={{
                    flex: 1,
                    overflow: 'auto',
                    '&::-webkit-scrollbar': {
                        width: '8px'
                    },
                    '&::-webkit-scrollbar-track': {
                        background: appColors.gray50,
                        borderRadius: '4px'
                    },
                    '&::-webkit-scrollbar-thumb': {
                        background: appColors.gray200,
                        borderRadius: '4px',
                        '&:hover': {
                            background: appColors.gray500
                        }
                    }
                }}
            >
                {renderAgreementPage()}
            </Box>

            {/* Actions */}
            <DialogActions
                sx={{
                    p: 3,
                    pt: 2,
                    borderTop: `1px solid ${appColors.gray200}`,
                    background: appColors.gray50
                }}
            >
                <Button
                    onClick={onClose}
                    variant="contained"
                    sx={{
                        borderRadius: '12px',
                        px: 3,
                        py: 1.5,
                        textTransform: 'none',
                        fontWeight: 600,
                        background: `linear-gradient(135deg, ${appColors.info} 0%, ${appColors.infoDark} 100%)`,

                        transition: 'all 0.3s ease',
                        '&:hover': {
                            transform: 'translateY(-2px)',

                            background: `linear-gradient(135deg, ${appColors.infoDark} 0%, ${appColors.infoDark} 100%)`,
                        }
                    }}
                >
                    Tamam
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AgreementDialog;
